import React, { useState, useEffect, useContext } from "react";

import PropsLoader from "./PropsLoader";
import UpdateTags from "../../../../Search/UpdateTags";
import Swal from "sweetalert2";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";

export const ShapesAndProps = (props) => {
  const [ShowItems, setShowItems] = useState(false);
  const { authenticationData,Role } = useContext(AuthContext);
  const [Itemid, setItemId] = useState(0);
  const [open, setOpen] = useState(false);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );
  const show = () => {
    if (ShowItems === false) {
      if (props.propGlobal === true) {
        props.setpropGlobal(false);
      } else {
        props.setpropGlobal(true);
      }
      setTimeout(() => {
        setShowItems(true);
      }, 50);
    } else {
      setShowItems(false);
    }
  };

  useEffect(() => {
    setShowItems(false);
  }, [props.propGlobal]);

  const ShapeandProps = (obj) => {
    setOpen(true);
    setItemId(obj.target.id);
  };

  const deleteProp = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        var formdata = new FormData();

        formdata.append("id", e.target.id);
        axios
          .post(
            authenticationData.ApiBaseURL + "/api/Administration/deleteProp",
            formdata,
            {
              headers: {
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.response == "Success") {
              props.getPropsFolderData();
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
              Swal.fire("Deleted!", "Not deleted", "Failed");
            }
          })
          .catch((excetion) => {
            //console.log(excetion);
          });
      }
    });
  };

  return (
    <>
    <div className="CharacterShow3">
        <div className="character_container">
          <div className="character_container_insider">
            <div className="Chr_cont_folder">
              <div className="chr_cont_name">{props.name}</div>

              <div
                className="Chr_folder_insider"
                onClick={show}
              >
                <span className="maskclas"></span>

                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  src={props.path}
                  alt=""
                />
              </div>

              <div
                className="folderExpand"
                onClick={() => {
                  setShowItems(!ShowItems);
                }}
              >
                {ShowItems && (
                  <span
                    style={{
                      top: "7px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                    className="material-icons folderExpand_icon"
                  >
                    close
                  </span>
                )}
                {!ShowItems && (
                  <span
                    style={{
                      top: "9px",
                      right: "12px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    className="material-icons folderExpand_icon"
                  >
                    expand_more
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {ShowItems && (
        <div
          className={
            props.indexes % 2 === 0
              ? "Character_folder_items"
              : "Character_folder_items"
          }
          style={{ width: "100%" }}
        >
          <div style={{ width: "100%", height: "auto" }}>
            <div className="Char_assetsList">
              {props.item &&
                props.item.map((obj, index) => (
                  <div key={index} className="Asset_items">
                     {Role == "admin" && ( <>
                    <div className="adminIconsUpload" title="Admin Edit Prop">
                      <span
                        id={obj.id}
                        className="material-icons"
                        onClick={(e) => ShapeandProps(e)}
                        style={{ fontSize: "14px", lineHeight: "12px" }}
                      >
                        edit
                      </span>
                    </div>
                    <div className="adminIconsDelete" title="Admin Prop Delete">
                      <span
                        className="material-icons"
                        onClick={deleteProp}
                        id={obj.id}
                        style={{ fontSize: "14px", lineHeight: "12px" }}
                      >
                        delete
                      </span>
                    </div>
                    </> ) }
                    {/* <div style={{ display: "flex" }}>
                      <span
                        id={obj.id}
                        onClick={(e) => ShapeandProps(e)}
                        className="material-icons"
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "0px",
                          color: "#9f9393",
                        }}
                      >
                        edit
                      </span>
                      <span
                        onClick={deleteProp}
                        id={obj.id}
                        className="material-icons"
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "20px",
                          color: "#9f9393",
                        }}
                      >
                        delete
                      </span>
                    </div> */}

                    <PropsLoader
                      Folder={"props-"}
                      ImgPath={obj.img}
                      name={props.name}
                      ind={index}
                      Item_Path={obj.item_Path}
                    />
                  </div>
                ))}

              {!props.item && (
                <div className="Asset_items" style={{ margin: "0 auto" }}>
                  <div
                    className="Asset_items_start"
                    style={{ textAlign: "center" }}
                  >
                    Coming Soon...
                  </div>
                </div>
              )}
              {open === true && (
                <UpdateTags
                  type={"Props"}
                  itemId={Itemid}
                  open={open}
                  setOpen={setOpen}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShapesAndProps;
